module.exports = __webpack_public_path__ + "static/img/ship-mosquito_256.ea40c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ship-mosquito_256.png
// module id = PDxy
// module chunks = 0